import { useRef, useState, useEffect } from "react";
import { useContextChat } from "../../Context/ContextChat";
import { IoMdSend } from "../../Context/exportIcons";
import { Col, Row } from "../../Tools/Grid-system";
import { content as transContent } from "../../Context/translate";
import { language } from "../../Tools/APIs";
import { useNavigate } from "react-router-dom";
import PopUp from "../../components/PopUps/PopUp";

const Messages = ({ index }) => {
  const [paddingBottom, setPaddingBottom] = useState("0px"); // Default padding bottom
  const { setNewMessage } = useContextChat();
  const [content, setContent] = useState("");
  const [showSubscriptionMessage, setShowSubscriptionMessage] = useState(false);
  const textarea = useRef();
  const dateTime = new Date();
  const navigate = useNavigate();

  const sendMessage = () => {
    setNewMessage({
      sendMessage: true,
      is_sent_by_auth_user: true,
      content: content,
      created_at: `${dateTime.toJSON()}`,
      key: Date.now(),
    });

    setContent("");
  };

  const handleSubscriptionConfirm = () => {
    setShowSubscriptionMessage(false);
    navigate("/packages");
  };

  const handleSubscriptionCancel = () => {
    setShowSubscriptionMessage(false);
  };

  // Listen for subscription expired events from MessageSender
  useEffect(() => {
    const handleSubscriptionExpired = () => {
      setShowSubscriptionMessage(true);
    };

    window.addEventListener('subscriptionExpired', handleSubscriptionExpired);

    return () => {
      window.removeEventListener('subscriptionExpired', handleSubscriptionExpired);
    };
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      sendMessage();
    }
  };

  const handleFocus = () => {
    // Assuming the keyboard height to be 50px in this example
    const keyboardHeight = 200;
    setPaddingBottom(`${keyboardHeight}px`);
  };

  const handleBlur = () => {
    setPaddingBottom("200px"); // Reset to default
  };

  return (
    <div
      className={`h-[10vh] max-md:fixed sticky left-0 max-md:bottom-[${paddingBottom}] bottom-0 w-full`}
    >
      <Row
        className={`px-4 !m-0 py-1 bg-slate-100 items-center  ${
          language === "ar" ? "flex-row-reverse" : ""
        }`}
      >
        <Col col={11} className="flex justify-center items-center ">
          <textarea
            onFocus={handleFocus}
            onBlur={handleBlur}
            ref={textarea}
            onKeyDown={handleKeyDown}
            name="content"
            value={content}
            placeholder={transContent.WriteMessage}
            onChange={(e) => setContent(e.target.value)}
            className={`w-full chat outline-1 outline-Main border-2 border-Secondary bg-white py-1 px-4 rounded-lg h-auto text-Secondary font-semibold text-md max-md:text-sm max-md:font-normal  ${
              language === "ar" ? "rtl" : "ltr"
            }`}
          ></textarea>
        </Col>
        <Col col={1}>
          <div className="flex justify-center items-center h-full w-full">
            <IoMdSend
              size={25}
              onClick={sendMessage}
              className={`cursor-pointer w-full text-Main hover:text-Secondary ${
                language === "ar" ? "rotate-180" : ""
              }`}
            />
          </div>
        </Col>
      </Row>
      
      <PopUp
        title="انتهى الاشتراك يجب ان تشتري باقة رسائل جديدة"
        show={showSubscriptionMessage}
        onClickFalse={handleSubscriptionCancel}
        onClick={handleSubscriptionConfirm}
      />
    </div>
  );
};

export default Messages;
